import { StrictMode } from "react";
import { appWithProviderBuilder, TUProvider } from "@2group/ui";
import { StyleProvider } from "antd-style";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { theme } from "../shared/config";
import "@2group/ui/tokens.css";
import "@/shared/styles/global.css";
import "@/shared/styles/reset.css";
import CustomAntStyles from "./providers/custom-ant/CustomAntStyles.tsx";
import ApiProvider from "./providers/query-client/QueryClientProvider.tsx";
import { BrowserRouter } from "react-router-dom";
import { StepProvider } from "@/shared/hooks/useGetSteps.tsx";
import { ConfigProvider } from "antd";

// Локали
import ruRu from "antd/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
dayjs.locale("ru");

const app = appWithProviderBuilder(<App />);

app.withProvider(StrictMode);

app.withProvider(BrowserRouter);
// @ts-ignore
app.withProvider(StyleProvider, { hashPriority: "high" });

app.withProvider(TUProvider, { overrideTheme: theme, prefixCls: "online-booking" });

app.withProvider(ConfigProvider, { locale: ruRu });
app.withProvider(CustomAntStyles);

app.withProvider(StepProvider);

app.withProvider(ApiProvider);

ReactDOM.createRoot(document.getElementById("root")!).render(app.build());
